export default {"src":"/_next/static/media/custom-home-head.bc5c9c9e.svg","height":1400,"width":2100};